// extracted by mini-css-extract-plugin
export default {"root":"l6YuE"};